import { memo } from 'react';
import { LayoutPopupOption } from '../../ClipCustomizer/Layout/constants';
import IconButton from '@/components/atoms/Button/IconButton';
import { classnames } from '@/libs/utils';
import Tooltip, { TooltipPosition } from '@/components/atoms/Button/Tooltip';

function ClipCustomizerLayoutIconButton({
  optionDetails,
  trackingId,
  isActive,
  isDisabled = false,
  disabledReason,
  onClick,
  tooltipPosition = 'left',
  onMouseEnter = () => {},
  onMouseLeave = () => {}
}: {
  optionDetails: LayoutPopupOption;
  trackingId: string;
  isActive: boolean;
  isDisabled?: boolean;
  disabledReason?: string;
  onClick: () => void;
  tooltipPosition?: TooltipPosition;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}) {
  return (
    <div onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} className="group relative">
      <IconButton
        icon={optionDetails.icon}
        content={optionDetails.label}
        variation="checkbox"
        trackingId={trackingId}
        disabled={isDisabled}
        buttonClassName={classnames(
          'relative flex w-full items-center justify-center space-x-1 !rounded-md border px-3 py-1 text-sm font-medium focus:!ring-black',
          isActive ? 'bg-white' : 'border-slate-200'
        )}
        onClick={onClick}
      />
      {isDisabled && disabledReason && (
        <div className="relative bottom-4">
          <Tooltip content={disabledReason} position={tooltipPosition} />
        </div>
      )}
    </div>
  );
}

export default memo(ClipCustomizerLayoutIconButton);
